export default __webpack_public_path__ + "static/media/vr_step_icon.7d95495c.svg";